import { render, staticRenderFns } from "./GeneSymbolReview.vue?vue&type=template&id=5dfc5bd3&scoped=true"
import script from "./GeneSymbolReview.vue?vue&type=script&lang=js"
export * from "./GeneSymbolReview.vue?vue&type=script&lang=js"
import style0 from "./GeneSymbolReview.vue?vue&type=style&index=0&id=5dfc5bd3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dfc5bd3",
  null
  
)

export default component.exports